import { useEffect } from 'react'

import {
  InputSelectControlContent,
  SelectControlEntityValueItem,
  useSelectContext,
} from '../../../Select'

function ProfileInfoWidgetSelectControlContent({ inputProps, ...restProps }) {
  const { handleClearSearch, isOpen, searchValue, value } = useSelectContext()

  useEffect(() => {
    if (!isOpen && searchValue) {
      handleClearSearch()
    }
  }, [isOpen])

  return (
    <InputSelectControlContent
      {...restProps}
      ValueItem={isOpen ? null : SelectControlEntityValueItem}
      inputProps={{ placeholder: value?.label, ...inputProps }}
    />
  )
}

export default ProfileInfoWidgetSelectControlContent
